import React, {useEffect} from "react";
import { objToFormData } from "../../../helpers/FormHelper";
import { createTipStep } from "../../../actions/mine_craft/tipStepsActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams, TipStepInterface } from "../../../store/mine_craft/tipStepsSlice";

import Form from './_partials/_Form';
import DrawerRight from "../../../componets/DrawerRight";
import AlertBlock from "../../../componets/AlertBlock";
import { selectTipById } from "../../../store/mine_craft/tipsSlice";
import { fetchTip } from "../../../actions/mine_craft/tipsActions";

const New = () => {
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.mineCraft.tipSteps.newParams);
  const error     = useAppSelector(state => state.mineCraft.tipSteps.newError);
  const tip       = useAppSelector(state => newParams?.tip_id ? selectTipById(state, newParams.tip_id) : undefined);

  let params: any = { ...newParams };

  useEffect(() => {
    if (newParams?.tip_id) {
      dispatch(fetchTip(newParams.tip_id));
    }
  }, [newParams, dispatch]);

  if (tip && params) {
    params.title_translations = {};
    params.empty_locales      = Object.keys(tip.title_translations);
  }

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function getLocaleRules() {
    const localeRules: any = {};

    if (tip) {
      Object.keys(tip.title_translations).forEach(key => localeRules[key] = { blank: false });
    }

    return localeRules;
  }

  function onFinish(data: TipStepInterface) {
    const rules    = { title_translations: getLocaleRules() };
    const formData = objToFormData(data, rules);

    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction  = await dispatch(createTipStep(data));

    if (createTipStep.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-tipStep'>
        <h6 className="v-content-label">Create TipStep</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        {tip && params && <Form onFinish={onFinish} params={params} />}
      </div>
    </DrawerRight>
  )
}

export default New;
